import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductCondition } from 'src/environments/environment';

@Component({
  selector: 'app-category-nav',
  templateUrl: './category-nav.component.html',
  styleUrls: ['./category-nav.component.scss'],
})
export class CategoryNavComponent implements OnInit {
  @Input() currentProductCondition: ProductCondition
  @Input() theme: string
  @Output() onChange = new EventEmitter<ProductCondition>();
  productCondition = ProductCondition;
  constructor() { }

  ngOnInit() { }
  changeValue(event) {
    event?.stopPropagation()
    this.onChange.emit(this.currentProductCondition);
  }


}
